export default __webpack_public_path__ + "static/media/CmdrKeepItReal.9b164aef.jpeg";